<template>
  <!--  顶部返回组件 -->
  <div
    class="back_"
    :style="{ top: $utils.px2rem(top + 'px') }"
    @click="goBack"
  >
    <img src="~@/assets/image/common/back_arrow.png" alt="" />
  </div>
</template>

<script>
export default {
  props: {
    // 定位top值
    top: {
      type: String,
      default: '10'
    }
  },
  methods: {
    goBack() {
      this.$router.go(-1)
    }
  }
}
</script>

<style lang="scss" scoped>
.back_ {
  display: flex;
  width: 20px;
  height: 20px;
  position: fixed;
  left: 0px;
  top: 0;
  z-index: 99;
  img {
    width: 100%;
    height: auto;
  }
}
</style>
